// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.contact-list--empty {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  padding: var(--space-lg);
  text-align: center;
}
.contact-list--empty p {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-secondary);
}
.contact-list--empty span {
  font-size: var(--font-size-sm);
  color: var(--theme-text-muted);
}
.contact-list__item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
  padding: 10px var(--space-md);
  border: none;
  border-left: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  text-align: left;
  width: 100%;
  transition: background 0.1s, border-color 0.1s;
}
.contact-list__item:hover {
  background: var(--theme-hover-neutral);
}
.contact-list__item--selected {
  background: var(--theme-selected-bg);
  border-left-color: var(--theme-primary);
}
.contact-list__item--selected:hover {
  background: var(--theme-primary-soft-hover);
}
.contact-list__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--theme-bg-tertiary);
}
.contact-list__avatar[data-color="0"] {
  background: #dbeafe;
}
.contact-list__avatar[data-color="1"] {
  background: #d1fae5;
}
.contact-list__avatar[data-color="2"] {
  background: #ede9fe;
}
.contact-list__avatar[data-color="3"] {
  background: #fce7f3;
}
.contact-list__avatar[data-color="4"] {
  background: #ffedd5;
}
.contact-list__avatar[data-color="5"] {
  background: #e0f2fe;
}
.contact-list__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.contact-list__avatar-initials {
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--theme-text-secondary);
}
.contact-list__avatar[data-color="0"] .contact-list__avatar-initials {
  color: #1d4ed8;
}
.contact-list__avatar[data-color="1"] .contact-list__avatar-initials {
  color: #065f46;
}
.contact-list__avatar[data-color="2"] .contact-list__avatar-initials {
  color: #5b21b6;
}
.contact-list__avatar[data-color="3"] .contact-list__avatar-initials {
  color: #9d174d;
}
.contact-list__avatar[data-color="4"] .contact-list__avatar-initials {
  color: #9a3412;
}
.contact-list__avatar[data-color="5"] .contact-list__avatar-initials {
  color: #075985;
}
.contact-list__info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-list__row1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xs);
}
.contact-list__name {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--theme-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.contact-list__tier {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  padding: 2px 6px;
  border-radius: var(--radius-xs);
  white-space: nowrap;
  flex-shrink: 0;
}
.contact-list__tier--close {
  background: var(--theme-primary-soft);
  color: var(--theme-primary-text);
}
.contact-list__tier--regular {
  background: #ecfdf5;
  background: var(--theme-success-bg, #ecfdf5);
  color: var(--theme-success);
}
.contact-list__tier--archived {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-muted);
}
.contact-list__company {
  font-size: var(--font-size-sm);
  color: var(--theme-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.contact-list__row3 {
  display: flex;
  gap: var(--space-sm);
  flex-wrap: wrap;
}
.contact-list__last, .contact-list__next {
  font-size: var(--font-size-xs);
  color: var(--theme-text-muted);
}
.contact-list__next {
  color: var(--theme-primary);
}
.contact-list__star {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-sm);
  border: none;
  background: transparent;
  color: var(--theme-text-muted);
  opacity: 0;
  cursor: pointer;
  padding: 0;
  transition: color 0.12s, opacity 0.12s, background 0.12s;
  align-self: center;
}
.contact-list__star:hover {
  color: var(--theme-primary);
  background: var(--theme-primary-soft);
}
.contact-list__star--active {
  color: var(--theme-primary);
  opacity: 1;
}
.contact-list__item:hover .contact-list__star {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/apps/ContactsApp/components/ContactList/ContactList.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AACJ;AACI;EACE,SAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;AACN;AAEI;EACE,8BAAA;EACA,8BAAA;AAAN;AAIE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,kCAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,8CAAA;AAFJ;AAII;EACE,sCAAA;AAFN;AAKI;EACE,oCAAA;EACA,uCAAA;AAHN;AAKM;EACE,2CAAA;AAHR;AAWE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AATJ;AAWI;EAAoB,mBAAA;AARxB;AASI;EAAoB,mBAAA;AANxB;AAOI;EAAoB,mBAAA;AAJxB;AAKI;EAAoB,mBAAA;AAFxB;AAGI;EAAoB,mBAAA;AAAxB;AACI;EAAoB,mBAAA;AAExB;AACE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;AAEE;EACE,eAAA;EACA,wCAAA;EACA,kCAAA;AAAJ;AAEI;EAA0C,cAAA;AAC9C;AAAI;EAA0C,cAAA;AAG9C;AAFI;EAA0C,cAAA;AAK9C;AAJI;EAA0C,cAAA;AAO9C;AANI;EAA0C,cAAA;AAS9C;AARI;EAA0C,cAAA;AAW9C;AANE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAQJ;AALE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AAOJ;AAJE;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAMJ;AAHE;EACE,8BAAA;EACA,sCAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,cAAA;AAKJ;AAHI;EACE,qCAAA;EACA,gCAAA;AAKN;AAFI;EACE,mBAAA;EAAA,4CAAA;EACA,2BAAA;AAIN;AADI;EACE,oCAAA;EACA,8BAAA;AAGN;AACE;EACE,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,oBAAA;EACA,eAAA;AAAJ;AAGE;EAEE,8BAAA;EACA,8BAAA;AAFJ;AAKE;EACE,2BAAA;AAHJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,wDAAA;EACA,kBAAA;AANJ;AAQI;EACE,2BAAA;EACA,qCAAA;AANN;AASI;EACE,2BAAA;EACA,UAAA;AAPN;AAYE;EACE,UAAA;AAVJ","sourcesContent":[".contact-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n\n  &--empty {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-xs);\n    padding: var(--space-lg);\n    text-align: center;\n\n    p {\n      margin: 0;\n      font-size: var(--font-size-base);\n      font-weight: var(--font-weight-medium);\n      color: var(--theme-text-secondary);\n    }\n\n    span {\n      font-size: var(--font-size-sm);\n      color: var(--theme-text-muted);\n    }\n  }\n\n  &__item {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--space-sm);\n    padding: 10px var(--space-md);\n    border: none;\n    border-left: 3px solid transparent;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    width: 100%;\n    transition: background 0.1s, border-color 0.1s;\n\n    &:hover {\n      background: var(--theme-hover-neutral);\n    }\n\n    &--selected {\n      background: var(--theme-selected-bg);\n      border-left-color: var(--theme-primary);\n\n      &:hover {\n        background: var(--theme-primary-soft-hover);\n      }\n    }\n  }\n\n  // ── Avatar ─────────────────────────────────────────────────────────────────\n  // 6 color slots, assigned deterministically by name hash\n\n  &__avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--theme-bg-tertiary);\n\n    &[data-color=\"0\"] { background: #dbeafe; }\n    &[data-color=\"1\"] { background: #d1fae5; }\n    &[data-color=\"2\"] { background: #ede9fe; }\n    &[data-color=\"3\"] { background: #fce7f3; }\n    &[data-color=\"4\"] { background: #ffedd5; }\n    &[data-color=\"5\"] { background: #e0f2fe; }\n  }\n\n  &__avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__avatar-initials {\n    font-size: 12px;\n    font-weight: var(--font-weight-semibold);\n    color: var(--theme-text-secondary);\n\n    .contact-list__avatar[data-color=\"0\"] & { color: #1d4ed8; }\n    .contact-list__avatar[data-color=\"1\"] & { color: #065f46; }\n    .contact-list__avatar[data-color=\"2\"] & { color: #5b21b6; }\n    .contact-list__avatar[data-color=\"3\"] & { color: #9d174d; }\n    .contact-list__avatar[data-color=\"4\"] & { color: #9a3412; }\n    .contact-list__avatar[data-color=\"5\"] & { color: #075985; }\n  }\n\n  // ── Info columns ───────────────────────────────────────────────────────────\n\n  &__info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__row1 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--space-xs);\n  }\n\n  &__name {\n    font-size: var(--font-size-base);\n    font-weight: var(--font-weight-medium);\n    color: var(--theme-text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__tier {\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-medium);\n    padding: 2px 6px;\n    border-radius: var(--radius-xs);\n    white-space: nowrap;\n    flex-shrink: 0;\n\n    &--close {\n      background: var(--theme-primary-soft);\n      color: var(--theme-primary-text);\n    }\n\n    &--regular {\n      background: var(--theme-success-bg, #ecfdf5);\n      color: var(--theme-success);\n    }\n\n    &--archived {\n      background: var(--theme-bg-tertiary);\n      color: var(--theme-text-muted);\n    }\n  }\n\n  &__company {\n    font-size: var(--font-size-sm);\n    color: var(--theme-text-secondary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__row3 {\n    display: flex;\n    gap: var(--space-sm);\n    flex-wrap: wrap;\n  }\n\n  &__last,\n  &__next {\n    font-size: var(--font-size-xs);\n    color: var(--theme-text-muted);\n  }\n\n  &__next {\n    color: var(--theme-primary);\n  }\n\n  // ── Favorite star button ───────────────────────────────────────────────────\n\n  &__star {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: var(--radius-sm);\n    border: none;\n    background: transparent;\n    color: var(--theme-text-muted);\n    opacity: 0;\n    cursor: pointer;\n    padding: 0;\n    transition: color 0.12s, opacity 0.12s, background 0.12s;\n    align-self: center;\n\n    &:hover {\n      color: var(--theme-primary);\n      background: var(--theme-primary-soft);\n    }\n\n    &--active {\n      color: var(--theme-primary);\n      opacity: 1;\n    }\n  }\n\n  // Show star on row hover (for non-favorites), always show active stars\n  &__item:hover &__star {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
